$(".js-tab-nav").on("click", function(e) {

	if (e) {
		e.preventDefault();
	}

	var menuItem = $(this).closest(".sidebar-menu__item");

	menuItem.siblings(".sidebar-menu__item").removeClass("sidebar-menu__item--active");
	menuItem.addClass("sidebar-menu__item--active");

	var section = $(this).attr("href").substring(1);
	var tab = $("[data-product-section=\"" + section + "\"]");
	var parent = tab.closest(".js-tabs-parent");
	var tabs = parent.find("[data-product-section]");

	tabs.removeClass("tab--active");
	tab.addClass("tab--active");

});